import axios from 'axios';
import config from '../constants/config';
import { v4 as uuidv4 } from 'uuid';

const customerPortalAxios = axios.create();
const customerPortalService = {};

/**
 * @typedef {Object} PendingTransactionData
 * @property {Object} paymentDetails
 * @property {Object} transactionDetails
 *
 * Note: For a better description of possible configurations, see transactionServiceSchemas and commonSchemas
 * in Api/validations/
 *
 * These properties should contain payment configurations for the following payment scenarios:
 * 1. One Time Card
 * 2. Payment Vault Card
 * 3. One Time ACH
 * 4. Payment Vault ACH
 */

/**
 * @async
 * @function runTransaction
 * @param {string} customerId
 * @param {PendingTransactionData} data
 * @returns {Promise<Object>}
 */
customerPortalService.runCustomerPortalTransaction = (customerId, data) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/customerPortal/transactions/${customerId}`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  return customerPortalAxios.post(url, data, { headers });
};

/**
 * Send transaction receipts to the customer (for resending)
 * @function sendCustomerReceipts
 * @param {import('../../../types/common').ObjectIdType} transactionId
 * @returns {AxiosPromise}
 */
customerPortalService.sendCustomerReceipts = (transactionId) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/customerPortal/transactions/${transactionId}/receipt`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'X-Correlation-ID': uuidv4(),
  };

  return customerPortalAxios.post(url, {}, { headers });
};

export default customerPortalService;
